import { createContext } from 'react';

// either default…
const UserContext = createContext(null);
export default UserContext;

// …or as a named export
// export const UserContext = createContext(null);
